import { useGetAllCategoryQuery } from "redux/api/category/category";
import { useEffect, useState } from "react";

export default function useAllCategories() {
    const [allCategories, setAllCategories] = useState([]);
    const { data, isLoading } = useGetAllCategoryQuery({
        paginator: {
            perPage: 1000, // Large number to get all categories
            page: 1
        }
    });

    useEffect(() => {
        if (data?.data) {
            setAllCategories(data.data);
        }
    }, [data]);

    return {
        allCategories,
        isLoading
    };
}
